const tabletSizes = {
  x8: 12,
  x10: 15,
  x12: 18,
  x14: 21,
  x16: 24,
  x18: 27,
  x20: 30,
  x26: 39,
};

export const fontSizes = tabletSizes;
